require('./index.css')

function LuckAnimation() {
  //�齱����
  this.StartGame = function (key, cb) {
    var _that = this
    lottery.inGame = true;
    // var keyArr = [-25,215,35,-85,155,95];//��Ӧ��ͬ�Ľ�Ʒ�ȼ��ĽǶȼ�ȥһ�㻡�ȼ���5  ������Ʒ  60/2+5 = -25
    var keyArr = [35, -25, 95, -85, 215, 155];
    var keyNum = 6;
    var tmpAng = Math.random() * (360 / keyNum - 10);
    jQuery("#luckyGift").rotate({
      angle: 0,
      animateTo: parseInt(1440 + keyArr[key - 1] + tmpAng),
      duration: 5000,
      easing: jQuery.easing.easeInOutExpo,
      callback: cb
    });
    setTimeout(function () {
      lottery.inGame = false;
    }, 6000)
  }
}

window.luckAnimation = new LuckAnimation()



// WEBPACK FOOTER //
// ./modules/lottery/turntable/index.js